(function () {
  const PROPERTY_NAMES = {
    leadSource: 'lead_source',
    utmSource: 'utm_source',
    utmMedium: 'utm_medium',
    utmCampaign: 'utm_campaign',
    gclidRaw: 'gclid',
    gbraid: 'gbraid',
    wbraid: 'wbraid',
    referrer: 'referrer',
    landingPage: 'landing_page',
  };

  const FIRST_TOUCH_PROPERTY_NAMES = {
    leadSource: 'first_lead_source',
    utmSource: 'first_utm_source',
    utmMedium: 'first_utm_medium',
    utmCampaign: 'first_utm_campaign',
    gadCampaignId: 'first_campaign_id',
    gclidRaw: 'first_gclid',
    gbraid: 'first_gbraid',
    wbraid: 'first_wbraid',
    referrer: 'first_referrer',
    landingPage: 'first_landing_page',
  };

  const mapProperties = (attribution, propertyNames) => {
    if (!attribution) return {};

    return Object.entries(propertyNames).reduce((properties, [sourceKey, propertyName]) => {
      const value = attribution[sourceKey];

      if (typeof value === 'string' && value.trim()) {
        properties[propertyName] = value.trim();
      }

      return properties;
    }, {});
  };

  const buildContactProperties = () => {
    const attribution = window.FlexikitchLeadAttribution?.get?.();
    return mapProperties(attribution, PROPERTY_NAMES);
  };

  const buildFirstTouchProperties = () => {
    const observations = window.FlexikitchLeadAttribution?.getObservations?.();
    if (!Array.isArray(observations)) return { first_touch_distinct: 'false' };

    const first = observations.find((observation) => observation?.touch_type === 'first');
    if (!first?.attribution || typeof first.captured_at !== 'string') {
      return { first_touch_distinct: 'false' };
    }

    return {
      first_touch_distinct: 'true',
      first_touch_captured_at: first.captured_at,
      ...mapProperties(first.attribution, FIRST_TOUCH_PROPERTY_NAMES),
    };
  };

  const setContactProperties = (properties, label) => {
    if (Object.keys(properties).length === 0) return false;

    try {
      window.tidioChatApi.setContactProperties(properties);
      return true;
    } catch (error) {
      console.warn(`Tidio ${label} attribution sync failed; continuing chat flow.`, error);
      return false;
    }
  };

  const syncContactProperties = () => {
    if (typeof window.tidioChatApi?.setContactProperties !== 'function') return false;

    const currentSynced = setContactProperties(buildContactProperties(), 'conversion');
    const firstSynced = setContactProperties(buildFirstTouchProperties(), 'first-touch');
    return currentSynced || firstSynced;
  };

  window.FlexikitchTidioAttribution = {
    getContactProperties: buildContactProperties,
    getFirstTouchProperties: buildFirstTouchProperties,
    sync: syncContactProperties,
  };

  if (window.tidioChatApi) {
    window.tidioChatApi.on('ready', syncContactProperties);
  } else {
    document.addEventListener('tidioChat-ready', syncContactProperties);
  }
})();
